export default "__VITE_ASSET__Caefm05N__"